// extracted by mini-css-extract-plugin
export default {"infoBlock":"BxzBjLCkBBE6asUq6K05","pulse":"xGDgNDvk7TotSXKK2mOm"};